<template>
  <mm-form
    ref="changeBillForm"
    :data="form"
    :rules="formRules"
    layout="vertical"
  >
    <mm-form-field
      label="发票类型"
      field="invoice_type"
      :required="true"
    >
      <mm-select
        v-model="form.invoice_type"
        :options="INVOICE_TYPE_OPTIONS"
        placeholder="请选择发票类型"
      />
    </mm-form-field>

    <mm-form-field label="发票抬头">
      <mm-input
        :value="displayInfo.company_name"
        disabled
        placeholder="发票抬头"
      />
    </mm-form-field>

    <mm-form-field label="发票税号">
      <mm-input
        :value="displayInfo.taxpayer_id"
        disabled
        placeholder="发票税号"
      />
    </mm-form-field>

    <mm-form-field
      v-if="needPaymentProof"
      label="代付款证明"
      field="proof_url"
      :required="true"
    >
      <div class="upload-wrapper">
        <upload-file
          v-model="proofFiles"
          accept="image/jpeg, image/png, .pdf"
          :max-byte="5 * 1024 * 1024"
          @onChange="handleProofUpload"
        />
        <a
          target="_blank"
          class="download-template"
          :class="{ 'disabled': loading }"
          @click="downloadTemplate"
        >
          🔗 下载模板.pdf
        </a>
      </div>
      <div class="upload-tips">
        支持 jpg、png、pdf 格式，文件小于 5M
      </div>
    </mm-form-field>
  </mm-form>
</template>

<script>
import UploadFile from "@/components/UploadFile/index.vue";
import { INVOICE_TYPE_OPTIONS } from "../constants";
import InvoiceApi from "@api/invoice";

export default {
  name: "ChangeBillHeaderForm",
  components: {
    UploadFile,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    displayInfo: {
      type: Object,
      default: () => ({}),
    },
    needPaymentProof: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      INVOICE_TYPE_OPTIONS,
      proofFiles: [],
      loading: false,
    };
  },
  computed: {
    formRules() {
      const rules = {
        invoice_type: [{ required: true, message: "请选择发票类型" }],
      };
      if (this.needPaymentProof) {
        rules.proof_url = [{ required: true, message: "请上传代付款证明" }];
      }
      return rules;
    },
  },
  methods: {
    validate() {
      return this.$refs.changeBillForm.validate();
    },
    handleProofUpload(files) {
      this.form.proof_url = files && files.length > 0 ? files[0].url : "";
    },
    resetProofState() {
      this.form.proof_url = "";
      this.proofFiles = [];
    },
    downloadTemplate() {
      InvoiceApi.downloadPaymentProof({ order_id: this.orderId })
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-wrapper {
  display: flex;
  align-items: center;

  .download-template {
    margin-left: 12px;
    color: #1890ff;
    font-size: 14px;
    cursor: pointer;

    &.disabled { 
      cursor: not-allowed;
      pointer-events: none;
      opacity: 0.5;
    }
  }
}

.upload-tips {
  margin-top: 4px;
  color: #999;
  font-size: 12px;
}
</style>
